//Utilities
var EventEmitter = require('events').EventEmitter;
var assign = require('object-assign');
var _ = require('lodash');
var Mapper = require('../utils/Mapper.js');
var Content = require('../services/ContentService').getContent();

//Component
var AppDispatcher = require('../core/AppDispatcher.jsx');
var ApplicationConstants = require('../constants/ApplicationConstants.js');
var PortfolioRebateConstants = require('../constants/PortfolioRebateConstants.js');
var AccountTypeConstants = require('../constants/AccountTypeConstants');

//local variables
var CHANGE_EVENT = 'change';

var _options = [], _rebatableList = [], _errorList = [], _inSpecieOptions=[], _invAllocationOptions = [];
var _showInvAllocationOptions = true, _showInSpecieOptions = false, _isSelectOptionDisabled = false;

var _portfolioRebateData = {
    linkAccountOption: '',
    portfolioRebateOption: PortfolioRebateConstants.PortfolioRebateValues.MORE_CONSERVATIVE,
    investmentOption: ''
};

function setRebatableList() {
    //get rebatable options
    _rebatableList = _.where(_options, { rebatePaymentOption: true });

    //sort by group sequence number
    _rebatableList = _.sortBy(_rebatableList, 'groupSequenceNumber');
}

function setOptions() {
    if (_showInvAllocationOptions && _showInSpecieOptions) {
        _options = _.cloneDeep(_invAllocationOptions);
        _.forEach(_inSpecieOptions,
            function (s) {
                if (!_.find(_options, { id: s.id })) {
                    _options.push(s);
                }
            });
    } else if (_showInvAllocationOptions) {
        _options = _.cloneDeep(_invAllocationOptions);
    } else if (_showInSpecieOptions) {
        _options = _.cloneDeep(_inSpecieOptions);
    } else {
        _options = []
    }
}

function setInvestmentAllocations(list) {
    var fmsCode;
    _errorList = [];
    if (list.length < _invAllocationOptions.length) {
        fmsCode = _.difference(_.pluck(_invAllocationOptions, 'fmsCode'), _.pluck(list, 'fmsCode'));
        if (fmsCode.length > 0 && _.find(_invAllocationOptions, function (o) { return o.fmsCode === fmsCode[0]; }).rebatePaymentOption) {
            _portfolioRebateData.investmentOption = '';
        }
    } else if (list.length !== _invAllocationOptions.length && _.last(list).rebatePaymentOption) {
        _portfolioRebateData.investmentOption = '';
        if (!_portfolioRebateData.portfolioRebateOption) {
            _portfolioRebateData.portfolioRebateOption = PortfolioRebateConstants.PortfolioRebateValues.MORE_CONSERVATIVE;
        }
    }

    _invAllocationOptions = _.clone(list);
    setOptions();
    setRebatableList();
    checkEligibleOptionAvailability();
    validatePortfolioRebates();
}

function setInspecieData(data) {
    _errorList = [];
    var newShowInvAllocationOptions = data.inSpecieModel.setUp === ApplicationConstants.YesNoValues.NO ||
        (data.inSpecieModel.setUp === ApplicationConstants.YesNoValues.YES
        && data.inSpecieModel.externalAccountQuestion !== ApplicationConstants.YesNoValues.YES);
    var newShowInSpecieOptions = data.inSpecieModel.setUp === ApplicationConstants.YesNoValues.YES;
    var isInSpecieSwitched = _showInvAllocationOptions !== newShowInvAllocationOptions || _showInSpecieOptions !== newShowInSpecieOptions;

    if (isInSpecieSwitched && _portfolioRebateData.portfolioRebateOption === PortfolioRebateConstants.PortfolioRebateValues.SELECT_OPTION) {
        // last setUp option is not the same as the new one, reset options
        _portfolioRebateData.investmentOption = '';
    }

    _showInvAllocationOptions = newShowInvAllocationOptions;
    _showInSpecieOptions = newShowInSpecieOptions;
    var accounts = _.cloneDeep(data.inSpecieAccounts);
    var investmentOptions = _.flatten(_.map(accounts, 'investmentOptions'));
    _inSpecieOptions = _.reduce(investmentOptions, function (result, value) {
        if (_.isString(value)) {
            value = value.replace(/,/g, '');
        }
        if (!_.find(result, { id: value.id }) && parseFloat(value.balance) > 0 && (!value.termDeposit)) {
            result.push(value);
        }
        return result;
    }, []);
    setOptions();
    setRebatableList();

    if (_showInSpecieOptions) {
        let indexOfManuallyInputtedAccount = _.findIndex(accounts,
            function (o) {
                return o.isExistingAccount === false;
            });

        _isSelectOptionDisabled = (indexOfManuallyInputtedAccount > -1);
        if (_isSelectOptionDisabled) {
            _portfolioRebateData.investmentOption = '';
            _portfolioRebateData.portfolioRebateOption = PortfolioRebateConstants.PortfolioRebateValues.MORE_CONSERVATIVE;
        }
    } else {
        _isSelectOptionDisabled = false
    }
    checkEligibleOptionAvailability();
    validatePortfolioRebates();
}

function validatePortfolioRebates() {
    _errorList = [];
    if (_isSelectOptionDisabled) return;
    if (_options.length === 0 && _portfolioRebateData.portfolioRebateOption) {
        _errorList.push({ message: Content.portfolioRebate.noInvestmentOptionError, id: 'portfolioRebateQuestion' });
    }
    else if (_rebatableList.length === 0 && _portfolioRebateData.portfolioRebateOption !== PortfolioRebateConstants.PortfolioRebateValues.MORE_CONSERVATIVE) {
        _errorList.push({ message: Content.portfolioRebate.invalidInvestmentOptionError, id: 'portfolioRebateQuestion' });
    }
}

function updatePortfolioRebateData(data) {
    if (data) {
        Mapper.objectMerger(_portfolioRebateData, data);
    }
}

function getMostConservativeOption() {
    var sortedByMostConservative = _.sortBy(_rebatableList, 'redemptionSequenceNumber');
    if (sortedByMostConservative.length > 0) {
        return sortedByMostConservative[0];
    }
    return null;
}

function clearPortfolioRebate() {
    _portfolioRebateData = {
        linkAccountOption: '',
        portfolioRebateOption: PortfolioRebateConstants.PortfolioRebateValues.MORE_CONSERVATIVE,
        investmentOption: ''
    };
    _errorList = [];
}

function checkEligibleOptionAvailability() {
    // if there is no eligbile options for rebate, Conservative should be used
    if (_options.length === 0 || _rebatableList.length === 0) {
        _portfolioRebateData.portfolioRebateOption = PortfolioRebateConstants.PortfolioRebateValues.MORE_CONSERVATIVE;
    }
}

function getFormModel() {
    var formModel = {
        portfolioRebateOption: '',
        investmentOption: '',
        investmentOptionDisplayName: '',
        linkAccountOption: ''
    }
    
    formModel.portfolioRebateOption = _portfolioRebateData.portfolioRebateOption;

    //if most conservative is selected use the most conservative investment option otherwise use what user selected
    if (_portfolioRebateData.portfolioRebateOption === PortfolioRebateConstants.PortfolioRebateValues.MORE_CONSERVATIVE) {
        let mostConsvOption = getMostConservativeOption();
        formModel.investmentOption = mostConsvOption ? mostConsvOption.id.toString() : '';
    }
    else {
        let selectedOption = _.find(_options, { id: parseInt(_portfolioRebateData.investmentOption) });
        formModel.investmentOption = _portfolioRebateData.investmentOption;
        formModel.investmentOptionDisplayName = selectedOption? (selectedOption.name + (selectedOption.code? (' (' + selectedOption.code + ')') : '')) : '';
    }

    //if user does not select any account to link, set the value to do not link
    if (_portfolioRebateData.linkAccountOption === '') {
        formModel.linkAccountOption = PortfolioRebateConstants.LinkAccountOptions.DONT_LINK;
    } else {
        formModel.linkAccountOption = _portfolioRebateData.linkAccountOption;
    }

    return formModel;
}

function retrievePortfolioRebate(data) {
    if (data) {
        _portfolioRebateData.portfolioRebateOption = data.portfolioRebateOption;
        _portfolioRebateData.investmentOption = data.investmentOption;
        _portfolioRebateData.linkAccountOption = data.linkAccountOption;
    }
}

var PortfolioRebateStore = assign({}, EventEmitter.prototype, {

    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },

    addChangeListener: function (callback) {
        this.on(CHANGE_EVENT, callback);
    },

    removeChangeListener: function (callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },

    getRebatableList: function () {
        return _rebatableList;
    },

    getPortfolioRebateModel: function () {
        return getFormModel();
    },

    getPortfolioRebateData: function () {
        return _.clone(_portfolioRebateData);
    },

    getErrorList: function () {
        return _errorList;
    },

    getIsSelectOptionDisabled: function() {
        return _isSelectOptionDisabled;
    }
});

PortfolioRebateStore.dispatchToken = AppDispatcher.register(function (action) {

    switch (action.actionType) {
        case ApplicationConstants.ActionTypes.SEND_INVESTMENT_OPTIONS:
            setInvestmentAllocations(action.investmentOptionList);
            break;
        case PortfolioRebateConstants.ActionTypes.UPDATE_PORTFOLIO_REBATE_DATA:
            updatePortfolioRebateData(action.data);
            validatePortfolioRebates();
            break;
        case ApplicationConstants.ActionTypes.APPLICATION_RETRIEVE_SUCCESS:
            retrievePortfolioRebate(action.applicationData.form.portfolioRebate);
            break;
        case AccountTypeConstants.ActionTypes.SELECT_ACCOUNT_TYPE:
            clearPortfolioRebate();
            break;
        case ApplicationConstants.ActionTypes.SEND_INSPECIE_DATA:
            setInspecieData(action.data);
            break;
        default:
            return true;
    }
    PortfolioRebateStore.emitChange();
    return true;
});

module.exports = PortfolioRebateStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/PortfolioRebateStore.js